export const sources={};export const img={src:"__VITE_ASSET__hd_BXCx25dCCiTFVAMV3Fg__",w:640,h:640};export default{sources:sources,img:img};